<template>
  <div class="page container">
    <div class="container">
      <div class="column">
        <div class="content">
          <h3>Quem somos nós</h3>
          <p>O Espaço Winnicott Brasília foi sendo construído ao longo dos anos a partir do desejo de profissionais e estudantes, principalmente da Psicologia, em estudar o pensamento e a clínica do psicanalista inglês D. W. Winnicott na cidade. Hoje somos diversos profissionais atuando nas mais diversas áreas na cidade e mantemos o desejo de construir ainda mais espaços potenciais a fim de nos aperfeiçoarmos e brincarmos de forma criativa, criando novos conhecimentos.</p>
          <p>O Espaço Winnicott Brasília oferece atividades diversas a estudantes e profissionais de várias áreas de atuação. Temos Curso de Formação, Cursos de Extensão, Grupos de Estudo e Supervisões de atendimentos clínicos.</p>
          <p>Dúvidas, sugestões ou críticas, faça um <a href="javascript://" @click='$router.push("/p/contato")'>contato</a>.</p>
          <h3>Nossa Missão</h3>
          <p>Oferecer um Espaço Potencial para a construção de conhecimento a partir do pensamento e da clínica de Winnicott em Brasília.</p>
        </div>
        <h3 class="is-size-4"></h3>
        <p class=""></p>
        
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'QuemSomos',
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .page{
    text-align: left
  }
  .container{
    max-width: 800px;
  }
</style>
